import { createSlice } from '@reduxjs/toolkit';
import FJAppConstant from '../../constants/FJAppConstant.js';
import FJConstant from '../../constants/FJConstant.js';
import {
    STOCK_TYPE_LIST,
    SUBTITLE_STYLE_LIST,
    TEXT_TO_IMAGE_STYLE_LIST,
    TEXT_TO_VIDEO_RATIO_LIST,
    TEXT_TO_VIDEO_STEP_LIST,
} from '../../config/dataConfig/FJTextToVideoDataConfig';

export const defaultTextToVideoState = {
    selectTab: FJAppConstant.TEXT_TO_FULL_VIDEO,
    textToVideoStepList: TEXT_TO_VIDEO_STEP_LIST,
    textToVideoStep: FJConstant.STEP_TYPE_HOME,
    sceneTextList: [],
    mediaSource: FJConstant.AI_GENERATED,
    ratio: TEXT_TO_VIDEO_RATIO_LIST[0],
    isLoadingLanguage: false,
    languageList: [],
    voiceList: [],
    voiceStyleList: [],
    languageValue: '',
    voiceValue: '',
    voiceStyleValue: '',
    voiceSpeed: 1,
    voicePitch: 1,
    textToImageStyle: TEXT_TO_IMAGE_STYLE_LIST[0],
    textToImageStyleList: TEXT_TO_IMAGE_STYLE_LIST,
    stockType: STOCK_TYPE_LIST[0],
    previewBtnStatus: FJConstant.IDLE,
    voiceSettingActive: true,
    subtitleSettingActive: true,
    subtitleStyle: SUBTITLE_STYLE_LIST[0],
    slateEditorNodes: [],
    scriptPasteText: '',
    urlToVideoInput: '',
    spiderData: {
        articleBody: '',
        images: [],
    },
    useSpiderImage: true,
    productUrlToVideoInput: '',
    productName: '',
    productDescription: '',
    productMediaList: [],
    pptFile: null,
    freeNumCreationInfo: {
        textToScript: 10,
        analysisUrl: 10,
        textToFullVideo: 3,
        blogUrlToVideo: 3,
        productUrlToVideo: 3,
        pptToVideo: 3,
    },
    totalCredit: 0,
};
export const FJSliceTextToVideo = createSlice({
    name: 'textToVideo',
    initialState: defaultTextToVideoState,
    reducers: {
        setSliceAll: (state, action) => {
            Object.assign(state, action.payload);
        },
        setSliceSelectTab: (state, action) => {
            state.selectTab = action.payload;
        },
        setSliceTextToVideoStep: (state, action) => {
            state.textToVideoStep = action.payload;
        },
        setSliceSceneTextList: (state, action) => {
            state.sceneTextList = action.payload;
        },
        setSliceMediaSource: (state, action) => {
            state.mediaSource = action.payload;
        },
        setSliceRatio: (state, action) => {
            state.ratio = action.payload;
        },
        setSliceLanguageList: (state, action) => {
            state.languageList = action.payload;
        },
        setSliceVoiceList: (state, action) => {
            state.voiceList = action.payload;
        },
        setSliceVoiceStyleList: (state, action) => {
            state.voiceStyleList = action.payload;
        },
        setSliceLanguageValue: (state, action) => {
            state.languageValue = action.payload;
        },
        setSliceVoiceValue: (state, action) => {
            state.voiceValue = action.payload;
        },
        setSliceVoiceStyleValue: (state, action) => {
            state.voiceStyleValue = action.payload;
        },
        setSliceVoiceSpeed: (state, action) => {
            state.voiceSpeed = action.payload;
        },
        setSliceVoicePitch: (state, action) => {
            state.voicePitch = action.payload;
        },
        setSliceIsLoadingLanguage: (state, action) => {
            state.isLoadingLanguage = action.payload;
        },
        setSliceTextToImageStyle: (state, action) => {
            state.textToImageStyle = action.payload;
        },
        setSliceTextToImageStyleList: (state, action) => {
            state.textToImageStyleList = action.payload;
        },
        setSliceStockType: (state, action) => {
            state.stockType = action.payload;
        },
        setSlicePreviewBtnStatus: (state, action) => {
            state.previewBtnStatus = action.payload;
        },
        setSliceVoiceSettingActive: (state, action) => {
            state.voiceSettingActive = action.payload;
        },
        setSliceSubtitleSettingActive: (state, action) => {
            state.subtitleSettingActive = action.payload;
        },
        setSliceSubtitleStyle: (state, action) => {
            state.subtitleStyle = action.payload;
        },
        setSliceTextToVideoStepList: (state, action) => {
            state.textToVideoStepList = action.payload;
        },
        setSliceSlateEditorNodes: (state, action) => {
            state.slateEditorNodes = action.payload;
        },
        setSliceScriptPasteText: (state, action) => {
            state.scriptPasteText = action.payload;
        },
        setSliceUrlToVideoInput: (state, action) => {
            state.urlToVideoInput = action.payload;
        },
        setSliceSpiderData: (state, action) => {
            state.spiderData = action.payload;
        },
        setSliceUseSpiderImage: (state, action) => {
            state.useSpiderImage = action.payload;
        },
        setSliceProductUrlToVideoInput: (state, action) => {
            state.productUrlToVideoInput = action.payload;
        },
        setSliceProductName: (state, action) => {
            state.productName = action.payload;
        },
        setSliceProductDescription: (state, action) => {
            state.productDescription = action.payload;
        },
        setSliceProductMediaList: (state, action) => {
            state.productMediaList = action.payload;
        },

        setSlicePptFile: (state, action) => {
            state.pptFile = action.payload;
        },
        setSliceFreeNumCreationInfo: (state, action) => {
            state.freeNumCreationInfo = action.payload;
        },
        setSliceTotalCredit: (state, action) => {
            state.totalCredit = action.payload;
        },
    },
});

export const {
    setSliceSelectTab,
    setSliceTextToVideoStep,
    setSliceSceneTextList,
    setSliceMediaSource,
    setSliceRatio,
    setSliceLanguageList,
    setSliceVoiceList,
    setSliceVoiceStyleList,
    setSliceLanguageValue,
    setSliceVoiceValue,
    setSliceVoiceStyleValue,
    setSliceVoiceSpeed,
    setSliceVoicePitch,
    setSliceIsLoadingLanguage,
    setSliceTextToImageStyle,
    setSliceTextToImageStyleList,
    setSliceStockType,
    setSlicePreviewBtnStatus,
    setSliceVoiceSettingActive,
    setSliceSubtitleSettingActive,
    setSliceSubtitleStyle,
    setSliceTextToVideoStepList,
    setSliceAll,
    setSliceSlateEditorNodes,
    setSliceScriptPasteText,
    setSliceUrlToVideoInput,
    setSliceSpiderData,
    setSliceUseSpiderImage,
    setSliceProductUrlToVideoInput,
    setSliceProductName,
    setSliceProductDescription,
    setSliceProductMediaList,
    setSlicePptFile,
    setSliceFreeNumCreationInfo,
    setSliceTotalCredit,
} = FJSliceTextToVideo.actions;

export default FJSliceTextToVideo.reducer;
